import React from 'react';
import PropTypes from 'prop-types';
import { DropDownMenu, MenuItem } from 'material-ui';


import './CompareTiles.css';
import '../../../../../grid.css';
import LineSavings from '../Graphs/LineSavings';
import { formattedNumber, formattedDollar } from '../../../../../utils/formatterHelpers';
import { OptionContainer } from './styles';


export default class CompareTiles extends React.Component {
    static propTypes = {
        annualResults: PropTypes.object.isRequired,
        setSelectedFinancing: PropTypes.func.isRequired,
        setMosaicTerm: PropTypes.func.isRequired,
        ppaRate: PropTypes.number.isRequired,
        ppaTerm: PropTypes.number.isRequired,
        ppaEscalator: PropTypes.number.isRequired,
        loanTerm: PropTypes.number.isRequired,
        downPayment: PropTypes.number.isRequired,
        systemSize: PropTypes.number.isRequired,
        provider: PropTypes.number.isRequired,
        energyValue: PropTypes.number.isRequired,
        annualInflation: PropTypes.number.isRequired,
        showPPA: PropTypes.bool.isRequired,
        showOBS: PropTypes.bool.isRequired,
        showLoan: PropTypes.bool.isRequired,
        showCAP: PropTypes.bool.isRequired,
        obsTerm: PropTypes.number.isRequired,
        capTerm: PropTypes.number.isRequired,
        capDownPayment: PropTypes.number.isRequired,
        obsDownPayment: PropTypes.number.isRequired,
        mosaicTerm: PropTypes.number.isRequired,
        loanProvider: PropTypes.string.isRequired,
        mosaicDownPayment: PropTypes.number.isRequired,
        resiToggle: PropTypes.bool.isRequired,
        isLocked: PropTypes.bool.isRequired,
        includeCash: PropTypes.bool.isRequired,
    };

    handleSelectPPA() {
        const { setSelectedFinancing } = this.props;
        setSelectedFinancing(1);
    }

    handleSelectLoan() {
        const { setSelectedFinancing } = this.props;
        setSelectedFinancing(2);
    }

    handleSelectOBS() {
        const { setSelectedFinancing } = this.props;
        setSelectedFinancing(3);
    }
    handleSelectCash() {
        const { setSelectedFinancing } = this.props;
        setSelectedFinancing(4);
    }

    handleMosaicTermChange(value) {
        const { setMosaicTerm } = this.props;
        setMosaicTerm(value);
    }


    render() {
        const {
            loanTerm,
            downPayment,
            isLocked,
            ppaRate,
            ppaTerm,
            ppaEscalator,
            systemSize,
            annualResults,
            provider,
            energyValue,
            annualInflation,
            showPPA,
            showOBS,
            showLoan,
            showCAP,
            obsTerm,
            obsDownPayment,
            capTerm,
            capDownPayment,
            mosaicTerm,
            loanProvider,
            resiToggle,
            mosaicDownPayment,
            includeCash,
        } = this.props;

        const cashTaxSavings = annualResults[1].macrs + annualResults[1].cashITC;
        const taxSavings = annualResults[1].macrs + annualResults[1].cashITC;
        let loanITC = annualResults[1].itc;
        if (loanProvider === 'mosaic' && resiToggle) {
            loanITC = annualResults[1].itc;
        }
        let monthlyLoan = annualResults[1].loanPayment / 12;
        if (loanProvider === 'mosaic') {
            monthlyLoan = annualResults[1].annualHomeLoanPayment / 12;
        }
        let upfrontFinancePayment = downPayment;
        if (loanProvider === 'mosaic') {
            upfrontFinancePayment = mosaicDownPayment;
        }
        const annualOBSPayment = annualResults[1].annualOBSPayment * 1;
        const annualCAPPayment = annualResults[1].annualCAPPayment * 1;
        const monthlyOBSPayment = annualOBSPayment / 12;
        const monthlyCAPPayment = annualCAPPayment / 12;
        const monthlyBill = annualResults[1].annualBill / 12;
        const totalCapPayments = annualResults[1].annualCAPPayment * capTerm / 12;

        let loanTitle = 'Loan';
        if (loanProvider === 'mosaic') {
            loanTitle = 'Mosaic';
        }

        return (
            <div className="tiles-container">
                <h3 className="comparetileTitle">
                    You have to buy electricity. The choice is yours.
                </h3>
                <div className="tileGraph">
                    <LineSavings />
                </div>
                <div className="row">
                    <h1 className="yearsLabel">Cumulative Cash in Hand</h1>
                </div>
                {loanProvider === 'mosaic' && showLoan ? (
                    <OptionContainer>
                        <h4>
                            Choose Your Mosaic Option
                        </h4>
                        <div>
                            <DropDownMenu
                                fullWidth
                                label="Mosaic Term"
                                value={mosaicTerm}
                                onChange={(e, index, value) =>
                                    this.handleMosaicTermChange(value)}
                                disabled={isLocked}
                            >
                                <MenuItem value={120} primaryText="Mosaic 10 Year / 3.99%" />
                                <MenuItem value={180} primaryText="Mosaic 15 Year / 4.99%" />
                                <MenuItem value={240} primaryText="Mosaic 20 Year / 5.49%" />
                            </DropDownMenu>
                        </div>
                    </OptionContainer>
                ) : null }
                <div className="tiles row">
                    <div className="utilityTile">
                        <h3>{provider}</h3>
                        <ul>
                            <li>
                                10yr Plan: ${formattedNumber(annualResults[10].cumulativeSolarSavings)}
                            </li>
                            <li>
                                20yr Plan: ${formattedNumber(annualResults[20].cumulativeSolarSavings)}
                            </li>
                            <li>
                                30yr Plan: ${formattedNumber(annualResults[30].cumulativeSolarSavings)}
                            </li>
                            <li>Utility Term: Forever</li>
                            <li>
                                Yr. 1 Annual Bill: ${formattedNumber(annualResults[1].annualBill)}
                            </li>
                            <li>
                                Yr. 1 Monthly Bill: ${formattedNumber(monthlyBill)}
                            </li>
                            <li>Utility Rate: ${energyValue}</li>
                            <li>Utility Inflation: {annualInflation}%</li>
                            <li>Tax Savings: $0</li>
                        </ul>
                    </div>
                    {showPPA ? (
                        <div
                            className="utilityTile"
                            onClick={e => this.handleSelectPPA(e)}
                            onKeyPress={e => this.handleSelectPPA(e)}
                            tabIndex={0}
                            role="button"
                        >
                            <h3>PPA</h3>
                            <ul>
                                <li>
                                    10yr Savings: ${formattedNumber(annualResults[10].cumulativePPASavings)}
                                </li>
                                <li>
                                    20yr Savings: ${formattedNumber(annualResults[20].cumulativePPASavings)}
                                </li>
                                <li>
                                    30yr Savings: ${formattedNumber(annualResults[30].cumulativePPASavings)}
                                </li>
                                <li>PPA Rate: ${ppaRate}</li>
                                <li>PPA Escalator: {ppaEscalator} %</li>
                                <li>PPA Term: {ppaTerm} years</li>
                                <li>Upfront Payment: $0</li>
                                <li>
                                    PPA Year 1: ${formattedNumber(annualResults[1].ppaBill)}
                                </li>
                                <li>Tax Savings: $0</li>
                            </ul>
                        </div>
                    ) : null }
                    {showLoan ? (
                        <div
                            className="utilityTile"
                            onClick={e => this.handleSelectLoan(e)}
                            onKeyPress={e => this.handleSelectLoan(e)}
                            tabIndex={0}
                            role="button"
                        >
                            <h3>{loanTitle}</h3>
                            <ul>
                                <li>
                                    10yr Savings:
                                    ${formattedNumber(annualResults[10].cumulativeLoanSavings)}
                                </li>
                                <li>
                                    20yr Savings:
                                    ${formattedNumber(annualResults[20].cumulativeLoanSavings)}
                                </li>
                                <li>
                                    30yr Savings:
                                    ${formattedNumber(annualResults[30].cumulativeLoanSavings)}
                                </li>
                                <li>Down Payment: ${formattedNumber(upfrontFinancePayment)}</li>
                                <li>
                                    Monthly Payment: ${formattedNumber(monthlyLoan)}
                                </li>
                                {resiToggle && loanProvider === 'mosaic' ?
                                    <li> Mosaic Term: {mosaicTerm} months</li>
                                    : <li>Loan Term: {loanTerm} months</li> }
                                {resiToggle && loanProvider === 'mosaic' ?
                                    <li>Tax Savings: ${formattedNumber(loanITC)}</li>
                                    : <li>Tax Savings: ${formattedNumber(taxSavings)}</li> }
                            </ul>
                        </div>
                    ) : null }
                    {showOBS && annualResults[1].cashprice > 499999.99999999 ? (
                        <div
                            className="utilityTile"
                            onClick={e => this.handleSelectOBS(e)}
                            onKeyPress={e => this.handleSelectOBS(e)}
                            tabIndex={0}
                            role="button"
                        >
                            <h3>Operating Lease</h3>
                            <ul>
                                <li>
                                    10yr Savings: ${formattedNumber(annualResults[10].cumulativeOBSSavings)}
                                </li>
                                <li>
                                    20yr Savings: ${formattedNumber(annualResults[20].cumulativeOBSSavings)}
                                </li>
                                <li>
                                    30yr Savings: ${formattedNumber(annualResults[30].cumulativeOBSSavings)}
                                </li>
                                <li>Lease Term: {obsTerm} months</li>
                                <li>Down Payment: ${formattedNumber(obsDownPayment)}</li>
                                <li>
                                    Monthly Payment: ${formattedNumber(monthlyOBSPayment)}
                                </li>
                                <li>Total Payments: $EDIT</li>
                            </ul>
                        </div>
                    ) : null }
                    {showCAP ? (
                        <div
                            className="utilityTile"
                            onClick={e => this.handleSelectOBS(e)}
                            onKeyPress={e => this.handleSelectOBS(e)}
                            tabIndex={0}
                            role="button"
                        >
                            <h3>Capital Lease</h3>
                            <ul>
                                <li>
                                    10yr Savings:
                                    ${formattedNumber(annualResults[10].cumulativeCAPSavings)}
                                </li>
                                <li>
                                    20yr Savings:
                                    ${formattedNumber(annualResults[20].cumulativeCAPSavings)}
                                </li>
                                <li>
                                    30yr Savings:
                                    ${formattedNumber(annualResults[30].cumulativeCAPSavings)}
                                </li>
                                <li>Lease Term: {capTerm} months</li>
                                <li>Down Payment: ${formattedNumber(capDownPayment)}</li>
                                <li>
                                    Monthly Payment: ${formattedNumber(monthlyCAPPayment)}
                                </li>
                                <li>Total Payments: ${formattedNumber(totalCapPayments)}</li>
                            </ul>
                        </div>
                    ) : null }
                    {includeCash ?
                        <div
                            className="utilityTile"
                            tabIndex={0}
                            role="button"
                            onClick={e => this.handleSelectCash(e)}
                            onKeyPress={e => this.handleSelectCash(e)}
                        >
                            <h3>Cash</h3>
                            <li>
                                10yr Savings: ${formattedNumber(annualResults[10].cumulativeCashSavings)}
                            </li>
                            <li>
                                20yr Savings: ${formattedNumber(annualResults[20].cumulativeCashSavings)}
                            </li>
                            <li>
                                30yr Savings: ${formattedNumber(annualResults[30].cumulativeCashSavings)}
                            </li>
                            <li>System Size: {formattedDollar(systemSize / 1000)} kW</li>
                            <li>
                                Cash Price: ${' '}
                                {formattedNumber(annualResults[1].cashprice)}
                            </li>
                            <li>Monthly Payment: $ 0</li>
                            <li>Tax Savings: ${formattedNumber(cashTaxSavings)}</li>
                            <li>Interest Paid: $ 0</li>
                        </div>
                        : null }
                    <div className="clearfixclass" />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/CompareTiles/CompareTiles.js